import React, { useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import emailjs from "emailjs-com";

const SERVICE_ID = "service_rfecciy";   // ✅ your actual Service ID
const TEMPLATE_ID = "template_awun1l8"; // ✅ your actual Template ID
const PUBLIC_KEY  = "-X18W1clM5HsqRDL-"; // ✅ your actual Public Key

const ContactForm = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const formRef = useRef();

  const [validator] = useState(
    new SimpleReactValidator({ className: "errorMessage" })
  );
  const [, forceUpdate] = useState(); // to re-render UI after validation

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessages();
    forceUpdate(1);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (validator.allValid()) {
      emailjs
        .sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
        .then(() => {
          alert("✅ Message sent successfully!");
          setForms({ name: "", email: "", subject: "", phone: "", message: "" });
          validator.hideMessages();
          forceUpdate(1);
        })
        .catch((err) => {
          console.error("❌ EmailJS Error:", err);
          alert("❌ Failed to send message, check your EmailJS keys & template.");
        });
    } else {
      validator.showMessages();
      forceUpdate(1);
    }
  };

  return (
    <form ref={formRef} onSubmit={submitHandler} className="contact-validation-active">
      <div className="row">
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.name}
              type="text"
              name="name"   // ⚠️ must match EmailJS template variable
              onChange={changeHandler}
              placeholder="Your Name"
              required
            />
            {validator.message("name", forms.name, "required|alpha_space")}
          </div>
        </div>

        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.email}
              type="email"
              name="email"   // ⚠️ must match EmailJS template variable
              onChange={changeHandler}
              placeholder="Your Email"
              required
            />
            {validator.message("email", forms.email, "required|email")}
          </div>
        </div>

        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.phone}
              type="tel"
              name="phone"   // ⚠️ must match EmailJS template variable
              onChange={changeHandler}
              placeholder="Your Phone"
              inputMode="tel"
              required
            />
            {validator.message("phone", forms.phone, "required")}
          </div>
        </div>

        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <select
              value={forms.subject}
              name="subject"   // ⚠️ must match EmailJS template variable
              onChange={changeHandler}
              required
            >
              <option value="">Select Service</option>
              <option>Home Interiors</option>
              <option>Commercial Interiors</option>
              <option>Office Interiors</option>
              <option>Electrical & Lighting Solutions</option>
              <option>Painting Works</option>
              <option>Plumbing Works</option>
              <option>Renovation Works</option>
              <option>Carpentry Works</option>
            </select>
            {validator.message("subject", forms.subject, "required")}
          </div>
        </div>

        <div className="col col-lg-12 col-12">
          <textarea
            value={forms.message}
            name="message"   // ⚠️ must match EmailJS template variable
            onChange={changeHandler}
            placeholder="Message"
            required
          />
          {validator.message("message", forms.message, "required|min:10")}
        </div>
      </div>

      <div className="submit-area">
        <button type="submit" className="theme-btn">Submit Now</button>
      </div>
    </form>
  );
};

export default ContactForm;
